<template>
  <div class="form-feedback-block embedded-feedback" :class="color">
    <div v-if="isFeedbackSent">
      <div v-if="isMessageOpened" class="form-feedback-box">
        <p class="form-feedback-success-message">Thanks for the feedback!</p>
        <a href="#" :class="submitButtonClass" @click="closeMessage">Close</a>
      </div>
    </div>
    <div v-else>
      <div class="form-feedback-link-wrapper">
        <a href="#" class="form-feedback-link" @click="toggler" ref="showFeedbackFormLink">{{ cta }}</a>
      </div>
      <transition name="slide">
        <div v-show="isBoxOpened">
          <div class="form-feedback-box">
            <form :data-form-name="`${type}_feedback`" data-form-overlay ref="feedbackForm">
              <p>{{ question }}</p>
              <div class="thumbs-wrapper">
                <input
                  type="checkbox"
                  :id="`find_helpful_yes_${type}_${widgetIndex}`"
                  value="true"
                  v-model="checkedHelpful"
                  @change="onCheck">
                <label :for="`find_helpful_yes_${type}_${widgetIndex}`"
                  class="icon-thumb icon-thumbs-up"
                  @keydown.enter="onCheckAda"
                  tabindex="0"></label>
                <input
                  type="checkbox"
                  :id="`find_helpful_no_${type}_${widgetIndex}`"
                  value="false"
                  v-model="checkedHelpful"
                  @change="onCheck">
                <label :for="`find_helpful_no_${type}_${widgetIndex}`"
                  class="icon-thumb icon-thumbs-down"
                  @keydown.enter="onCheckAda"
                  tabindex="0"></label>
              </div>
              <p>Please tell us more:</p>
              <textarea :placeholder="placeholder" v-model="message"></textarea>
              <button
                title="Submit"
                :class="submitButtonClass"
                :disabled="checked"
                @click="onSubmit">Submit</button>
              <a
                href="#"
                :class="cancelButtonClass"
                @click="onCancel">Cancel</a>
            </form>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { each } from 'lodash'

export default {
  props: ['type', 'cta', 'question', 'placeholder', 'extras', 'color', 'dataId'],
  data() {
    return {
      isBoxOpened: false,
      isFeedbackSent: false,
      checkedHelpful: [],
      message: '',
      isMessageOpened: true,
      widgetIndex: Number
    }
  },

  computed: {
    cancelButtonClass() {
      return this.color === "blue"
        ? "f-button white"
        : "w-button white small";
    },
    submitButtonClass() {
      const baseClass = this.color === "blue" ? "f-button blue" : "w-button purple small";
      return `${baseClass} ${this.checked ? 'disabled' : ''}`.trim();
    },
    feedbackPath() {
      return SOPHIA.Routes.feedback_path()
    },
    checked() {
      return this.checkedHelpful.length == 0
    }
  },

  mounted() {
    this.widgetIndex = $(this.$el).parents('sophia-feedback').data('index')
  },

  methods: {
    toggler(e) {
      e.preventDefault()
      let eventAction
      this.isBoxOpened = !this.isBoxOpened
      if (this.isBoxOpened) {
        SOPHIA.formGA($(this.$refs.feedbackForm), 'form_view')
        eventAction = 'expand'
      } else {
        eventAction = 'collapse'
      }

      SOPHIA.clickToggleForGA({
        el: $(this.$refs.showFeedbackFormLink),
        eventAction,
        moduleName: this.type + '_feedback_form',
        fieldType: 'drawer',
        clickText: $(e.target).text()
      })
    },

    onCheckAda(e) {
      $('#' + $(e.target).attr('for')).trigger("click")
    },

    onCheck(e) {
      if (this.checkedHelpful.length > 1) {
        this.checkedHelpful.shift() // uncheck another checkbox, only one checkbox should be checked
      }

      const $thumb = $(e.target)

      SOPHIA.clickToggleForGA({
        el: $thumb,
        eventAction: $thumb.attr('id'),
        moduleName: this.type + '_feedback_form',
        fieldType: 'radio_button',
        clickText: this.checkedHelpful[0]
      })
    },

    onChangeUsage(e) {
      const $usage = $(e.target)
      const $usageText = $usage.siblings(".form-feedback-option-label").text()

      SOPHIA.clickToggleForGA({
        el: $usage,
        eventAction: $usage.attr('id'),
        moduleName: this.type + '_feedback_form',
        fieldType: 'radio_button',
        clickText: $usageText
      })
    },

    onSubmit(e) {
      e.preventDefault()
      const data = {
        feedback: {
          helpful: this.checkedHelpful[0] === 'true',
          copy: this.message,
          feedback_type: this.type,
          data: {}
        }
      }

      if (this.extras) {
        each(this.extras, (value, key) => {
          // replace '-' with '_' in the attribute, e.g. course-id => course_id
          const underscoreKey = key.replace(/[\s-]+/g, '_')
          data.feedback.data[underscoreKey] = value
        })
      }

      const xhrData = {
        url: this.feedbackPath,
        type: 'POST',
        data: data,
        dataType: 'json'
      };

      const callbacks = {
        afterSuccess: () => {
          this.isFeedbackSent = true
          SOPHIA.formGA($(this.$refs.feedbackForm), 'form_submit')
          localStorage.setItem(`feedback-submitted-${this.dataId}`, '1')
        },
        afterError: xhr => {
          if (xhr.responseJSON && xhr.responseJSON.errors) {
            this.errors = xhr.responseJSON.errors
          }
        }
      };

      SOPHIA.sendXHR(xhrData, callbacks);
    },

    onCancel(e) {
      this.toggler(e)
      this.checkedHelpful = []
      this.message = ''
    },

    closeMessage(e) {
      e.preventDefault()
      this.isMessageOpened = false
    }
  }
}
</script>
